import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";


/*
 dc-js chart template
  */

/*  Create a pie chart and use the given css selector as anchor. You can also specify
    an optional chart group for this chart to be scoped within. When a chart belongs
    to a specific group then any interaction with such chart will only trigger redraw
    on other charts within the same chart group.
*/
const genderFinancingChartFunc = (divRef, ndx) => {
        /* Remove null groups*/
  function remove_empty_bins(source_group) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
          return d.value !== 0; // if integers only
        });
      },
    };
    }
    /* create the gender dimension*/
    const dimension = ndx.dimension((d) => d.gender_of_Finance_Recipient);
/* reduce the gender group by summing teicket  size */

    const group = dimension.group().reduceSum((d) => d.ticketSize);
    /* get the sum total sum of the ticket sizes */
    const all = ndx.groupAll().reduceSum((d) => d.ticketSize);
    /* create the gender finance chart */
  const genderFinanceChart = dc.pieChart(divRef);
  genderFinanceChart
    .dimension(dimension)
    .group(remove_empty_bins(group))
    .width(140) // set the width  of the chart
      .height(180) // set  the height of the chart
      .legend(dc.legend().legendWidth(500).x(10).y(165).highlightSelected(true).horizontal(true))
      .drawPaths(true)
      // calculate and return the slice percentages on  render and post  render
    .on("pretransition", function (chart) {
      chart.selectAll("text.pie-slice").text(function (d) {
        return (
          dc.utils.printSingleValue(
            Math.floor((d.value / all.value()) * 100).toFixed(1) // format  th
          ) + "%"
        );
      });
    })
    .innerRadius(4) // set the inner chart radius
      .transitionDuration(1500) // create chart animation
      .colors(d3.scaleOrdinal().domain(["Male", "Female"]).range(["#2156AF", "#49B6A6"]))
      /*.ordinalColors(d3.scaleOrdinal().range(["#2156AF", "#49B6A6"]))*/
    //.ordinalColors(["#2156AF", "#49B6A6"]) // set  the chart color
    .colorAccessor((d) => d.value); // set the values to  be used in calculating the pie slices
  return genderFinanceChart;  // return the chart
};

export const GenderFinanceChart = (props) => (
    <ChartTemplate  chartFunction={genderFinancingChartFunc}
    title="Gender of Finance Recipient"
  />
);
